import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CommonModule, AsyncPipe } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { Observable } from 'rxjs'
import { PrivateMessage } from '../../../models/privateMessage'
import { map, tap } from 'rxjs/operators'
import { PrivateMessagesListComponent } from '../private-messages-list/private-messages-list.component'

export type MessageDirection = 'inbound' | 'outbound'

@Component({
  selector: 'app-private-message-list-wrapper',
  standalone: true,
  imports: [CommonModule, IonicModule, PrivateMessagesListComponent, AsyncPipe],
  templateUrl: './private-message-list-wrapper.component.html',
  styleUrls: ['./private-message-list-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateMessageListWrapperComponent implements OnInit {
  TAG = 'PrivateMessageListWrapperComponent'

  @Input() inboundMessages$: Observable<PrivateMessage[]>
  @Input() outboundMessages$: Observable<PrivateMessage[]>

  @Output() replyToMessage = new EventEmitter<PrivateMessage>()
  @Output() loadInboundPrivateMessagesFromOffset = new EventEmitter<number>()
  @Output() loadOutboundPrivateMessagesFromOffset = new EventEmitter<number>()
  @Output() filterByAssistantId = new EventEmitter<number>()
  @Output() filterByClientId = new EventEmitter<number>()
  @Output() filterBySenderId = new EventEmitter<number>()
  @Output() fetchOnlyUnread = new EventEmitter<boolean>()

  activeTab: MessageDirection = 'inbound'

  sortedInboundMessages$: Observable<PrivateMessage[]>
  sortedOutboundMessages$: Observable<PrivateMessage[]>

  // private inboundMessagesLoadedLength: number = 0
  // private outboundMessagesLoadedLength: number = 0

  ngOnInit() {
    console.log(`${this.TAG}#onInit`)

    this.sortedInboundMessages$ = this.inboundMessages$.pipe(
      tap((e) => console.log('new inbound msg', e)),
      map((msgs) => {
        return msgs.sort(this.sortByPublishedAt)
      }),
    )

    this.sortedOutboundMessages$ = this.outboundMessages$.pipe(
      tap((e) => console.log('new outbound msg', e)),
      map((msgs) => {
        return msgs.sort(this.sortByPublishedAt)
      }),
    )

    this.loadMoreInboundMsgs()
    this.loadMoreOutboundMsgs()
  }

  sortByPublishedAt = (a, b) => {
    if (a.publishedAt < b.publishedAt) return 1
    if (a.publishedAt > b.publishedAt) return -1
    return 0
  }

  constructor() {}

  activeTabChange(event: CustomEvent) {
    this.activeTab = event.detail.value
  }

  loadMoreInboundMsgs(offset = 0) {
    console.log('loading more inbound messages...')
    this.loadInboundPrivateMessagesFromOffset.emit(offset)
  }

  loadMoreOutboundMsgs(offset = 0) {
    console.log('loading more outbound messages...')
    this.loadOutboundPrivateMessagesFromOffset.emit(offset)
  }
}
